import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core, Decorative, TopShop } from "@faire/design-tokens";
import { FaireMarketIcon } from "@faire/retailer-visitor-shared/features/FaireMarkets/FaireMarketIcon";
import { handleKeyDown } from "@faire/retailer-visitor-shared/lib/handleKeyDown";
import { handleMouseDown } from "@faire/retailer-visitor-shared/lib/handleMouseDown";
import { useIsSearchPage } from "@faire/retailer-visitor-shared/lib/useIsSearchPage";
import { assignSettingOnEvent } from "@faire/retailer-visitor-shared/settings/assignSettingOnEvent";
import { getSettingElevateTopShopV2 } from "@faire/retailer-visitor-shared/settings/getSettingElevateTopShopV2";
import { useAssignSettingEnableOnMouseDownFilters, useGetSettingEnableOnMouseDownFilters } from "@faire/retailer-visitor-shared/settings/useSettingEnableOnMouseDownFilters";
import { MarketStore } from "@faire/retailer-visitor-shared/stores/domain/Events/FaireMarkets/MarketStore";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { optimizeImageUrl } from "@faire/web--source/common/transform-images";
import { Pill } from "@faire/web--source/slate/Filter/styled";
import { Insider } from "@faire/web--source/slate/icons/InsiderIcon";
import { ActiveTrophySecondary, TrophyIcon } from "@faire/web--source/slate/icons/Trophy";
import { Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { DefaultTheme } from "@faire/web--source/slate/Theme";
import { FaireMarketTheme } from "@faire/web--source/slate/Theme/EventsTheme";
import { ThemeProvider } from "@faire/web--source/slate/Theme/ThemeProvider";
import { Typography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { IFilterSection } from "@faire/web-api--source/indigofair/data/IFilterSection";
import React from "react";
import styled, { css } from "styled-components";
// eslint-disable-next-line complexity
export var FilterToggle = function(param) {
    var className = param.className, section = param.section, onChange = param.onChange, _param_showLoading = param.showLoading, showLoading = _param_showLoading === void 0 ? false : _param_showLoading, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var option = section.options.length > 0 ? section.options[0] : undefined;
    var isInsider = section.field_name === IFilterSection.FieldName.INSIDER;
    var isTopShop = section.field_name === IFilterSection.FieldName.TOP_SHOP;
    var _option_is_selected;
    var isSelected = (_option_is_selected = option === null || option === void 0 ? void 0 : option.is_selected) !== null && _option_is_selected !== void 0 ? _option_is_selected : false;
    var isDisabled = disabled && !isSelected;
    var _section_is_invisible;
    var isInvisible = (_section_is_invisible = section.is_invisible) !== null && _section_is_invisible !== void 0 ? _section_is_invisible : false;
    var isMarketSpecials = section.field_name === IFilterSection.FieldName.MAKER_SPECIAL && MarketStore.get().isLive;
    var assignEnableOnMouseDownFilters = useAssignSettingEnableOnMouseDownFilters();
    var isSearchPage = useIsSearchPage();
    var isMouseDownEnabled = useGetSettingEnableOnMouseDownFilters() && isSearchPage;
    var isSSR = useIsSSR();
    var settingAssignmentRef = useDoActionWhenVisible(function() {
        var _section_settings_to_assign;
        (_section_settings_to_assign = section.settings_to_assign) === null || _section_settings_to_assign === void 0 ? void 0 : _section_settings_to_assign.forEach(function(setting) {
            assignSettingOnEvent(setting);
        });
    });
    var _option_results_count;
    if (!showLoading && (option === null || option === void 0 ? void 0 : option.key) === undefined || ((_option_results_count = option === null || option === void 0 ? void 0 : option.results_count) !== null && _option_results_count !== void 0 ? _option_results_count : 1) === 0 && !isSelected) {
        return null;
    }
    var onToggle = function() {
        if (option !== undefined && !isDisabled) {
            var newIsSelected = !(option === null || option === void 0 ? void 0 : option.is_selected);
            var updatedSection = _object_spread_props(_object_spread({}, section), {
                options: section.options.map(function(option, index) {
                    return index === 0 ? _object_spread_props(_object_spread({}, option), {
                        is_selected: newIsSelected
                    }) : option;
                })
            });
            var _option_key;
            onChange(updatedSection, (_option_key = option.key) !== null && _option_key !== void 0 ? _option_key : "", newIsSelected);
        }
    };
    var handleOnMouseDown = function() {
        if (isSearchPage) {
            assignEnableOnMouseDownFilters();
            if (isMouseDownEnabled) {
                onToggle();
            }
        }
    };
    var renderDisplayName = function() {
        if (isInsider) {
            var _option_key;
            return /*#__PURE__*/ _jsx(StyledText, {
                id: "toggle-".concat((_option_key = option === null || option === void 0 ? void 0 : option.key) !== null && _option_key !== void 0 ? _option_key : ""),
                color: isSelected ? Core.text.inverse : Decorative.shade.teal,
                variant: "paragraphSansMedium",
                children: section.display_name
            });
        } else if (isMarketSpecials) {
            var _option_key1;
            return /*#__PURE__*/ _jsxs(Row, {
                align: "center",
                children: [
                    /*#__PURE__*/ _jsx(FaireMarketIcon, {
                        size: "16px"
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: "1x"
                    }),
                    /*#__PURE__*/ _jsx(StyledText, {
                        id: "toggle-".concat((_option_key1 = option === null || option === void 0 ? void 0 : option.key) !== null && _option_key1 !== void 0 ? _option_key1 : ""),
                        variant: "paragraphSansRegular",
                        color: "inherit",
                        children: section.display_name
                    })
                ]
            });
        }
        var _option_key2;
        return /*#__PURE__*/ _jsx(StyledText, {
            id: "toggle-".concat((_option_key2 = option === null || option === void 0 ? void 0 : option.key) !== null && _option_key2 !== void 0 ? _option_key2 : ""),
            variant: "paragraphSansRegular",
            color: isSelected ? Core.text.inverse : Core.text.default,
            children: section.display_name
        });
    };
    var getImage = function() {
        var filterImage = null;
        if (isInsider) {
            filterImage = /*#__PURE__*/ _jsx(Insider, {
                small: true,
                color: isSelected ? Core.icon.inverse : Decorative.icon.teal
            });
        } else if (isTopShop) {
            if (isSelected) {
                filterImage = /*#__PURE__*/ _jsx(ActiveTrophySecondary, {
                    color: TopShop.shade.green,
                    fill: TopShop.shade.green,
                    fontSize: "medium",
                    titleAccess: ""
                });
            } else {
                filterImage = /*#__PURE__*/ _jsx(TrophyIcon, {
                    active: true,
                    fontSize: "medium",
                    color: Core.icon.inverse,
                    fill: Core.icon.inverse,
                    titleAccess: ""
                });
            }
        } else {
            if (option === null || option === void 0 ? void 0 : option.image) {
                filterImage = /*#__PURE__*/ _jsx(ToggleImage, {
                    width: 16,
                    src: optimizeImageUrl(option.image, isSSR, {
                        width: 16
                    })
                });
            }
        }
        if (filterImage) {
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    filterImage,
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: 4
                    })
                ]
            });
        }
        return null;
    };
    var getPillStyles = function() {
        var styles = {};
        if (isSelected) {
            styles.color = Core.text.inverse;
            styles.backgroundColor = Core.surface.default;
            if (isInsider) {
                styles.backgroundColor = Decorative.shade.teal;
            } else if (isTopShop) {
                styles.backgroundColor = TopShop.shade.green;
            }
        } else if (showLoading) {
            styles.backgroundColor = Core.surface.subdued;
        } else {
            styles.border = "1px solid ".concat(Core.border.muted);
            styles.backgroundColor = Core.surface.inverse;
        }
        if (isDisabled) {
            styles.backgroundColor = Core.surface.subdued;
            styles.cursor = "not-allowed";
        }
        return styles;
    };
    var getHoverColor = function() {
        if (isInsider && !isSelected) {
            return Decorative.shade.teal;
        } else if (isTopShop && !isSelected) {
            return TopShop.shade.green;
        } else if (!isSelected && !showLoading && !isDisabled) {
            return Core.border.default;
        }
        return undefined;
    };
    var _section_display_name;
    return /*#__PURE__*/ _jsx("div", {
        ref: settingAssignmentRef,
        children: /*#__PURE__*/ _jsx(Wrapper, {
            className: "".concat(className !== null && className !== void 0 ? className : "", " ").concat(isInvisible ? "hidden" : ""),
            role: "button",
            "aria-pressed": isSelected,
            onClick: isMouseDownEnabled ? undefined : onToggle,
            onMouseDown: handleMouseDown(handleOnMouseDown),
            onKeyDown: handleKeyDown(onToggle),
            tabIndex: isDisabled ? -1 : 0,
            "aria-label": (_section_display_name = section.display_name) !== null && _section_display_name !== void 0 ? _section_display_name : strictLocalize({
                id: "7NriMG",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Loading"
                    }
                ]
            }),
            "data-test-id": "filter-toggle-wrapper-".concat(section.display_name),
            style: {
                opacity: isDisabled ? 0.5 : 1
            },
            children: isTopShop && !getSettingElevateTopShopV2() ? null : /*#__PURE__*/ _jsx(ThemeProvider, {
                theme: isMarketSpecials ? FaireMarketTheme : DefaultTheme,
                children: /*#__PURE__*/ _jsxs(StyledPill, {
                    isOpen: false,
                    alwaysShowCloseButton: false,
                    hasFilterSelected: isSelected,
                    style: getPillStyles(),
                    $hoverColor: getHoverColor(),
                    children: [
                        getImage(),
                        showLoading ? /*#__PURE__*/ _jsx(LoadingTextPlaceholder, {}) : null,
                        renderDisplayName()
                    ]
                })
            })
        })
    });
};
var Wrapper = styled.div.withConfig({
    componentId: "sc-dde444aa-0"
})([
    "width:max-content;&:focus-visible{border-radius:40px;}"
]);
var ToggleImage = styled.img.withConfig({
    componentId: "sc-dde444aa-1"
})([
    "margin-left:3px;"
]);
var StyledText = styled(Typography).withConfig({
    componentId: "sc-dde444aa-2"
})([
    "&&&{width:max-content;}"
]);
var StyledPill = styled(Pill).withConfig({
    componentId: "sc-dde444aa-3"
})([
    "padding:",
    ";",
    ""
], getSpacing(0, 16), function(param) {
    var $hoverColor = param.$hoverColor;
    return $hoverColor ? css([
        "&:hover{border:1px solid ",
        " !important;}"
    ], $hoverColor) : null;
});
var LoadingTextPlaceholder = styled.div.withConfig({
    componentId: "sc-dde444aa-4"
})([
    "height:16px;width:115px;background-color:",
    ";"
], Core.surface.inverse);
